import { Action } from 'adaptivecards';
import { PIN_ADDIN_COMMAND } from '../utils/adaptiveCardActionTypes';
export default class PinAddinCommandAction extends Action {
    public productId: string;
    public newPinnedStatus: boolean;

    constructor() {
        super();
        this.productId = '';
        this.newPinnedStatus = false; //true-pinned false-unpinned
    }

    parse(json: any) {
        super.parse(json);
        this.isPrimary = json.isPrimary;
        this.productId = json.productId;
        this.newPinnedStatus = json.newPinnedStatus;
    }

    getJsonTypeName(): string {
        return PIN_ADDIN_COMMAND;
    }
}
